// src/apiConstants.js

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.thirdwavemicrocare.com/api'; //https://api.thirdwavemicrocare.com/api // http://localhost:3001/api

export const API_LOGIN = `${API_BASE_URL}/login`;

// Define the endpoints for different API calls
export const API_UPDATE_CENTER = `${API_BASE_URL}/update-center`;
export const API_CENTERS = `${API_BASE_URL}/centers`;
export const API_ADD_CENTER = `${API_BASE_URL}/add-center`;


// Define the endpoints for different API calls for clients
export const API_GET_CLIENTS = `${API_BASE_URL}/get-client`;
export const API_UPDATE_CLIENT_STATUS = `${API_BASE_URL}/update-client-status`;
export const API_ADD_CLIENT = `${API_BASE_URL}/add-client`;


// Define the endpoints for different API calls
export const API_ADD_LOAN_REPAYMENT = `${API_BASE_URL}/add-loan-repayment`;
export const API_GET_REPAYMENT_PAID = `${API_BASE_URL}/get-repayment-paid`;

// Define the endpoints for different API calls for loan management
export const API_GET_LOANS = `${API_BASE_URL}/get-loans`;
export const API_ADD_LOAN_DISBURSE = `${API_BASE_URL}/add-loan-disburse`;
export const API_ADD_LOAN_REPAYMENT_MULTIPLE = `${API_BASE_URL}/add-loan-repayment-multiple`;
export const API_GET_CLIENTS_FOR_REPAYMENT = `${API_BASE_URL}/get-clients-for-repayment`;

// Define the endpoints for different API calls for report
export const API_GET_ADVANCE_REPAYMENT = `${API_BASE_URL}/get-advance-repayment`;
export const API_GET_REPAYMENT_REPORT = `${API_BASE_URL}/get-repayment-report`;



